import { createSelector } from 'reselect';

const shopifySelector = state => state.shopify;

export const shopifyShopsSelector = createSelector(
  shopifySelector,
  shopify => shopify.shops,
);

export const shopifyShopSelector = createSelector(
  shopifySelector,
  shopify => shopify.shop,
);

export const shopifyMultipleOrdersSelector = createSelector(
  shopifySelector,
  shopify => shopify.multipleOrders,
);

export default {};
